import React, { useState } from "react";
import { useController, Controller } from "react-hook-form";
import InputMask from 'react-input-mask';
import _ from "lodash";

/* eslint-disable */
export const MaskField = React.forwardRef((props, ref) => {
  const { field, fieldState } = useController(props);
  const [focusState, setFocusState] = useState(false);
  const { title, style, errors, defaultValue, customStyle, onChange, mask="99/99/9999", isDisabled=false,...others } = props;
  let err = _.get(errors, props.name)
  return (

    <div className="w-full">
        <div className={`${customStyle ? customStyle : 'h-[35px]'}  relative w-full border border-gray ${style ? 'bg-white' : ''} bg-white focus-within:bg-white outlineStyle rounded ${props?.rules && err ? "focus-within:border-red-600 border-red-600" : "focus-within:border-teal-c-900"}`}>
            <Controller
            name={props?.name}
            control={props?.control}
            rules={props?.rules}
            defaultValue={defaultValue}
            render={({ field}) => (
                <InputMask 
                    {...props}
                    {...field}
                    inputRef={(elem) => {
                        field?.ref(elem);
                        if(ref) {
                            ref.current = elem;
                        }
                    }}
                    ref={()=>{}} // don't remove this function beacuse its using in useController
                    mask={mask}
                    onBlurCapture={() => {
                        field.onBlur;
                        setFocusState(false)}
                    }
                    onFocus={() => setFocusState(true)}
                    onChange={e => {
                        field.onChange(e);
                        if (props.onChange) {
                            props.onChange(e, props?.name);
                        }
                    }}
                    disabled={isDisabled ?isDisabled :false}
                    placeholder={props.placeholder ? props.placeholder : ''}
                    value={field.value}
                    className={`block w-full p-1 appearance-none focus:outline-none focus:ring-0 text-base font-light text-black-300 ${isDisabled ? "bg-gray-50 cursor-not-allowed" : "bg-transparent"}`} {...others}
                />
            )}
            />
            <div
            className={`pointer-events-none absolute ml-2 left-0 duration-300 origin-0 mr-2 inline-block px-1 font-normal  ${props?.rules && err ? "text-red-600" : "text-gray-600"}  ${focusState || !field.value == "" || field.value == "0"
                ? "-top-2 duration-300 bg-[white] text-xs rounded-lg"
                : "top-2 duration-300 text-base xl:top-1"
                } `}
            >
            {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
            </div>

        </div>
        {props.rules && err &&
            <p className=" text-xs text-red-600 h-3 text-left" id="email-error">
                {props.rules && err && (
                props.rules && err?.message
                )}
            </p>
        }
    </div>
  );
});